// Platforms on which audience overlap can be calculated, in the order they appear
export const AUDIENCE_OVERLAP_PROVIDERS = ["instagram", "tiktok", "youtube"];

export const AUDIENCE_OVERLAP_POLLING_INTERVAL = 5000;
// 24 attempts every 5 seconds: the analysis has 2 minutes to finish
export const AUDIENCE_OVERLAP_POLLING_MAX_ATTEMPTS = 24;
// Polling also gives up earlier when the API does not know about the analysis anymore a few times in a row
export const AUDIENCE_OVERLAP_POLLING_MAX_MISSING_STATES = 3;
// the same limit as MAX_CREATORS of WsCreatorsAudienceOverlapQueryService, which rejects bigger selections
export const MAX_CREATORS_PER_PLATFORM_FOR_AUDIENCE_OVERLAP = 100;
